<template>
    <div class="loader">
        <p class="loader__label">Updating</p>
        <div class="loader__figure"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Moment from 'moment'

    export default {
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style>

    .loader {
        float: right;
        height: 20px;
        margin-right: 10px;
        color: #556270;



        position: absolute;
        top: 0px;
        right: 0;
        left: 0;
    
    }

.loader__figure {
     
  float:right;
  box-sizing: border-box;
  margin-top:2.5px;
  margin-right:5px;
  border: 0 solid #556270;
  border-radius:50%;
  -webkit-animation: loader-figure 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
  -moz-animation: loader-figure 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
  animation: loader-figure 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}

    .loader__label {
        height: 15px;
        font-size: 15px;
        float: right;
        margin-bottom: 2.5px;
        margin-block-end: 0px;
        margin-block-start: 0px;
        -webkit-animation: loader-label 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
        -moz-animation: loader-label 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
        animation: loader-label 1.15s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
    }

@-webkit-keyframes loader-figure {
  0% {
    height: 0;
    width: 0;
    background-color: #556270;
  }
  29% {
    background-color: #556270;
  }
  30% {
    height: 15px;
    width: 15px;
    background-color: transparent;
    border-width: 7px;
    opacity: 1;
  }
  100% {
    height: 15px;
    width: 15px;
    border-width: 0;
    opacity: 0;
    background-color: transparent;
  }
}
@-moz-keyframes loader-figure {
  0% {
    height: 0;
    width: 0;
    background-color: #556270;
  }
  29% {
    background-color: #556270;
  }
  30% {
    height: 15px;
    width: 15px;
    background-color: transparent;
    border-width: 7px;
    opacity: 1;
  }
  100% {
    height: 15px;
    width: 15px;
    border-width: 0;
    opacity: 0;
    background-color: transparent;
  }
}
@keyframes loader-figure {
  0% {
    height: 0;
    width: 0;
    background-color: #556270;
  }
  29% {
    background-color: #556270;
  }
  30% {
    height: 15px;
    width: 15px;
    background-color: transparent;
    border-width: 7px;
    opacity: 1;
  }
  100% {
    height: 15px;
    width: 15px;
    border-width: 0;
    opacity: 0;
    background-color: transparent;
  }
}
@-webkit-keyframes loader-label {
  0% {
    opacity: 0.25;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
@-moz-keyframes loader-label {
  0% {
    opacity: 0.25;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
@keyframes loader-label {
  0% {
    opacity: 0.25;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
